import { ComparablesFilterFields } from "../components";

export const disabledZooplaFields = new Set<ComparablesFilterFields>([]);
export const disabledEPCFields = new Set<ComparablesFilterFields>([
  "bedrooms",
  "yearBuiltFrom",
  "yearBuiltTo",
]);
